// GA tracking dropdown
export const GA_CATEGORY_LISTING = 'listing';
export const GA_ACTION_SHARE_EVENT = 'Share';
export const GA_ACTION_CONTACT_ORG_ATTEMPT_EVENT = 'ContactOrgAttempt';
